var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './AppDisplay.scss';
import classNames from 'classnames';
import { DataSecurityAppLogos } from './DataSecurityAppLogos';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { Tag } from 'antd';
import { useApplicationReference } from '@hooks';
import { Else, If, Then, When } from 'react-if';
import { SwapLeftOutlined, SwapOutlined, SwapRightOutlined } from '@ant-design/icons';
function getDirectionIcon(read, write) {
    if (read === undefined && write === undefined) {
        return null;
    }
    if (read && write) {
        return React.createElement(SwapOutlined, null);
    }
    if (read) {
        return React.createElement(SwapRightOutlined, null);
    }
    if (write) {
        return React.createElement(SwapLeftOutlined, null);
    }
    return null;
}
export const AppDisplay = (_a) => {
    var _b;
    var { appId, appLabel, appName, className, hideArrows, hideLabel, loading, read, write } = _a, rest = __rest(_a, ["appId", "appLabel", "appName", "className", "hideArrows", "hideLabel", "loading", "read", "write"]);
    const { label, name } = useApplicationReference(appId);
    const logo = (_b = DataSecurityAppLogos[(appName || name)]) !== null && _b !== void 0 ? _b : '';
    const appDisplayClassNames = classNames('application-display', className);
    return (React.createElement("div", Object.assign({ className: appDisplayClassNames }, rest),
        React.createElement(LoadingSpinner, { indicator: React.createElement("div", null), spinning: loading },
            React.createElement(Tag, { className: 'application-name' },
                React.createElement(When, { condition: !hideArrows }, getDirectionIcon(read, write)),
                React.createElement(If, { condition: logo },
                    React.createElement(Then, null,
                        React.createElement("img", { className: 'application-logo', src: logo })),
                    React.createElement(Else, null,
                        React.createElement("div", { className: 'application-name-text' }, appName || name)))),
            React.createElement(When, { condition: (appLabel || label) && !hideLabel },
                React.createElement(Tag, { className: 'application-label' }, appLabel || label)))));
};
